import { createApp } from "vue";
import App from "../App.vue";
import router from "../router";
import StripePayment from '../components/Payments/StripePayment.vue'
import IdentityVerification from "../components/Verification/IdentityVerification";
import GCContributorApp from '../components/GroupCard/GroupCardContributorMain.vue'
import axios from 'axios'
import VueAxios from 'vue-axios';

//import VueSweetalert2 from 'vue-sweetalert2';
//import BootstrapVue3 from 'bootstrap-vue-3'
//import 'bootstrap/dist/css/bootstrap.css';
//import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
//import 'sweetalert2/dist/sweetalert2.min.css';
//import jquery from 'jquery'

createApp(App).use(router)
    //.use(BootstrapVue3)
    .use(VueAxios, axios)
    //.use(VueSweetalert2)
    .mount("#app");
createApp(GCContributorApp).mount('#groupCardContributorCarousel')
createApp(StripePayment).mount('#stripe-payment')
createApp(IdentityVerification).mount('#identity-verification')